import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=51c8e1e8&scoped=true"
import script from "./categories.vue?vue&type=script&lang=js"
export * from "./categories.vue?vue&type=script&lang=js"
import style0 from "./categories.vue?vue&type=style&index=0&id=51c8e1e8&prod&scoped=true&lang=css"
import style1 from "./categories.vue?vue&type=style&index=1&id=51c8e1e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c8e1e8",
  null
  
)

export default component.exports